import Tabs from './tabs';
import { TabsProps, TabPaneProps } from './interface';

export { TabsProps, TabPaneProps };

export default Tabs;
